import React, { useState } from 'react';
import { loadModules } from "esri-loader";
import coloradoStations from "../../Data/colorado_substations.json";
import illinoisStations from "../../Data/illinois_substations.json";

export function loadMap(container, basemap) {
  return loadModules(
    ["esri/Map", "esri/views/MapView", "esri/Graphic", "esri/layers/FeatureLayer"],
    // this stylesheet is only loaded once
    { css: "https://js.arcgis.com/4.10/esri/css/main.css" }
  ).then(([Map, MapView, Graphic, FeatureLayer]) => {

    const map = new Map({ basemap: 'osm' });
    var currentObjecId = 0

    

    const lineLayer = new FeatureLayer({
      // url: "https://services.arcgis.com/V6ZHFr6zdgNZuVG0/ArcGIS/rest/services/Electric_Line/FeatureServer/110",
      url: "https://services1.arcgis.com/Hp6G80Pky0om7QvQ/arcgis/rest/services/Transmission_Lines_gdb/FeatureServer/0",      
      popupTemplate: {
        title: "{NAME}",
        outFields: ["OWNER", "VOLTAGE", "SUB_1", "SUB_2"],
        lastEditInfoEnabled: false,
        actions: [
          {
            id: "find-station",
            image: "https://developers.arcgis.com/javascript/latest//sample-code/popup-custom-action/live/beer.png",
            title: "station Info"
          }
        ],
        content: [
          {
            type: "fields",
            fieldInfos: [
              {
                fieldName: "OWNER"
              },
              {
                fieldName: "VOLTAGE",                
              },
              {
                fieldName: "SUB_1",
              },
              {
                fieldName: "SUB_2"
              }
            ]
          }
        ]
      }
    });

    const distLayer = new FeatureLayer({
      url: "https://services.arcgis.com/V6ZHFr6zdgNZuVG0/ArcGIS/rest/services/Electric_Distribution_Device/FeatureServer/0",
      popupTemplate: {
        title: "{name}",
        lastEditInfoEnabled: false,
        actions: [
          {
            id: "find-distribution",
            image: "https://developers.arcgis.com/javascript/latest//sample-code/popup-custom-action/live/beer.png",
            title: "Distribution Device Info"
          }
        ],
        content: [
          {
            type: "fields",
            fieldInfos: [
              {
                fieldName: "name"
              },
              {
                fieldName: "ASSETTYPE"
              },
              {
                fieldName: "ASSETGROUP"
              },
              {
                fieldName: "phasescurrent"
              },
              {
                fieldName: "phasesnormal"
              },
              {
                fieldName: "devicestatus"
              }
            ]
          }
        ]
      }
    });

    const distCVLayer = new FeatureLayer({
      url: "https://services.arcgis.com/V6ZHFr6zdgNZuVG0/ArcGIS/rest/services/Electric_Distribution_Device_CVs/FeatureServer/0",
      popupTemplate: {
        title: "{name}",
        lastEditInfoEnabled: false,
        actions: [
          {
            id: "find-distribution",
            image: "https://developers.arcgis.com/javascript/latest//sample-code/popup-custom-action/live/beer.png",
            title: "Distribution Device Info"
          }
        ],
        content: [
          {
            type: "fields",
            fieldInfos: [
              {
                fieldName: "name"
              },
              {
                fieldName: "ASSETTYPE"
              },
              {
                fieldName: "ASSETGROUP"
              },
              {
                fieldName: "phasescurrent"
              },
              {
                fieldName: "phasesnormal"
              },
              {
                fieldName: "devicestatus"
              }
            ]
          }
        ]
      }
    });

    // const station1Graphic = new Graphic({
    //   geometry: {
    //     type: "point",
    //     longitude: -105.007369,
    //     latitude: 39.627244
    //   },
    //   symbol: {
    //     type: "picture-marker",
    //     url: "/images/SubstationImage.png",
    //     color: [252, 140, 3],  // Blue
    //     width: 20,
    //     height: 20,
    //     outline: {
    //       color: [255, 255, 255], // White
    //       width: 8
    //     },
    //   },
    //   attributes: {
    //     Name: "Substation",
    //     Description: "Xcel Substation"
    //   },
    //   popupTemplate: {
    //     title: "{Name}",
    //     actions: [
    //       {
    //         id: "find-substation",
    //         image: "https://static.thenounproject.com/png/2496215-200.png",
    //         title: "Xcel Substation"
    //       }
    //     ],
    //     content: [
    //       {
    //         type: "fields",
    //         fieldInfos: [
    //           {
    //             fieldName: "Xcel Substation"
    //           },
    //           {
    //             fieldName: ""
    //           },
    //           {
    //             fieldName: "Littleton"
    //           },
    //           {
    //             fieldName: "CO"
    //           },
    //           {
    //             fieldName: ""
    //           },
    //           {
    //             fieldName: ""
    //           }
    //         ],
    //       },
    //     ],
    //   }

    // });

    const sbsOfficeGraphic = new Graphic({
      geometry: {
        type: "point",
        longitude: -105.012296,
        latitude: 39.6129881
      },
      symbol: {
        type: "simple-marker",
        color: [40, 43, 226],  // Blue
        outline: {
          color: [255, 255, 255], // White
          width: 4
        },
      },
      attributes: {
        Name: "SBS Corporate Headquarters",
        Description: "SBS Corporate",
        Website: "https://www.spatialbiz.com/",
        StationId: "1"
      },
      popupTemplate: {
        title: "{Name}",
        wbsite: "{Website}",
        stationId : "{StationId}",
        actions: [
          {
            id: "find-SBS",
            image: "https://static.thenounproject.com/png/2496215-200.png",
            title: "SBS Office"
          }
        ],
        content: [
          {
            type: "fields",
            fieldInfos: [
              {
                fieldName: "SBS Corporate"
              },
              {
                fieldName: "1890 West Littleton Blvd"
              },
              {
                fieldName: "Littleton"
              },
              {
                fieldName: "CO"
              },
              {
                fieldName: "1 303-847-4200"
              },
              {
                fieldName: "website"
              }
            ],
          },
        ],
      }
    });



    const view = new MapView({
      container,
      map,
      center: [-105.009065, 39.618691], // Longitude, latitude
      zoom: 15, // Zoom level
    });

    map.add(lineLayer);
    map.add(distLayer);
    map.add(distCVLayer);


    // view.graphics.add(station1Graphic);
    view.graphics.add(sbsOfficeGraphic);
    // view.graphics.add(station2Graphic);

    coloradoStations.forEach((stationData, index) => {

      var stationGraphic = new Graphic({
        geometry: {
          type: "point",
          longitude: stationData.LONGITUDE,
          latitude: stationData.LATITUDE
        },
        symbol: {
          type: "simple-marker",
          color: [226, 119, 40],  // Orange
          outline: {
            color: [255, 255, 255], // White
            width: 4
          },
        },
        attributes: {
          Name: stationData.NAME,
          Description: stationData.NAICS_DESC,
          ObjectId: stationData.OBJECTID
        },
        popupTemplate: {
          title:"{Name}",
          objectId: "{ObjectId}",
          actions: [
            {
              id: "find-substation",
              image: "https://static.thenounproject.com/png/2496215-200.png",
              title: `Load ${stationData.NAME}`
            }
          ],
          content: [
            {
              type: "fields",
              fieldInfos: [
                {
                  fieldName: `Station Name: ${stationData.NAME}`
                },
                {
                  fieldName: `Max Voltage: ${stationData.MAX_VOLT}`
                },
                {
                  fieldName: `Min Voltage: ${stationData.MIN_VOLT}`
                },
                {
                  fieldName: `No. of Lines: ${stationData.LINES}`
                },
                {
                  fieldName: `NAICS Desc: ${stationData.NAICS_DESC}`
                },
                {
                  fieldName: `City: ${stationData.CITY}`
                },
                {
                  fieldName: `County: ${stationData.COUNTY}`
                },
                {
                  fieldName: `Status: ${stationData.STATUS}`
                },
                {
                  fieldName: `Updated On: ${stationData.SOURCEDATE}`
                }
              ],
            },
          ],
        }
      })
      view.graphics.add(stationGraphic);
    });


    illinoisStations.forEach((stationData, index) => {

      var stationGraphic = new Graphic({
        geometry: {
          type: "point",
          longitude: stationData.LONGITUDE,
          latitude: stationData.LATITUDE
        },
        symbol: {
          type: "simple-marker",
          color: [226, 119, 40],  // Orange
          outline: {
            color: [255, 255, 255], // White
            width: 4
          },
        },
        attributes: {
          Name: stationData.NAME,
          Description: stationData.NAICS_DESC
        },
        popupTemplate: {
          title: "{Name}",
          actions: [
            {
              id: "find-substation",
              image: "https://static.thenounproject.com/png/2496215-200.png",
              title: "Substation"
            }
          ],          
          content: [
            {
              type: "fields",
              fieldInfos: [
                {
                  fieldName: `Station Name: ${stationData.NAME}`
                },
                {
                  fieldName: `Max Voltage: ${stationData.MAX_VOLT}`
                },
                {
                  fieldName: `Min Voltage: ${stationData.MIN_VOLT}`
                },
                {
                  fieldName: `No. of Lines: ${stationData.LINES}`
                },
                {
                  fieldName: `NAICS Desc: ${stationData.NAICS_DESC}`
                },
                {
                  fieldName: `City: ${stationData.CITY}`
                },
                {
                  fieldName: `County: ${stationData.COUNTY}`
                },
                {
                  fieldName: `Status: ${stationData.STATUS}`
                },
                {
                  fieldName: `Updated On: ${stationData.SOURCEDATE}`,
                }
              ],
            },
          ],
        }
      })
     
      view.graphics.add(stationGraphic);
    });

    view.when(() => {
      // Watch for when features are selected
      view.popup.watch("selectedFeature", (graphic) => {
        if (graphic) {          
          // Set the action's visible property to true if the 'website' field value is not null, otherwise set it to false
          const graphicTemplate = graphic.getEffectivePopupTemplate();
          graphicTemplate.actions.items[0].visible = graphic.attributes.ObjectId ? true : false;
        }
      });

      const popup = view.popup;
      popup.viewModel.on("trigger-action", (event) => {
        if (event.action.id === "find-substation") {
          const attributes = popup.viewModel.selectedFeature.attributes;
          // Get the 'website' field attribute
          const info = attributes.ObjectId;          
          // Make sure the 'website' field value is not null
          if (info) {
            // Open up a new browser using the URL value in the 'website' field
            // window.open(info.trim());
          
            var domElem = document.getElementById('selectedStation');   
            domElem.innerText = attributes.Name; //attributes.ObjectId;              
            localStorage.setItem('projectName', attributes.Name);
          }
        }
      });
    });



    return view;
  });
}
